import { useSelector } from "react-redux";
import { useEffect } from "react";
import i18n from "./utils/i18n/i18n";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Routelist from "./route/Route";

// Initialize Stripe (put this outside the component)
const stripePromise = loadStripe(
  "pk_test_51OEHt8Ke5HSZjo7pTNuhtdMQZDZkKYXUupS2CvnsYZ6nbshxS1jwnhLz1DPEKH28FV6z3I2IpZ3j9nuhxyYtjXoe00TXkB7jSv"
); // Replace with your actual Stripe publishable key

function App() {
  const { userLang } = useSelector((state) => state.Auth);

  console.log("user lang on app", userLang);
  useEffect(() => {
    i18n.changeLanguage(userLang);
  }, [userLang]);

  return (
    <Elements stripe={stripePromise}>
      <div>
        <Routelist />
      </div>
    </Elements>
  );
}

export default App;
